import { IUser } from '@common/interfaces/user'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'user'

export const LIST_REQUEST = `${prefix}/LIST_REQUEST`
export const LIST_SUCCESS = `${prefix}/LIST_SUCCESS`
export const LIST_FAILURE = `${prefix}/LIST_FAILURE`

export const listUsers = createAction((params: object) => ({
  type: [LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE],
  promise: (api: IApi) => api.user.list(params),
}))

export const SHOW_REQUEST = `${prefix}/SHOW_REQUEST`
export const SHOW_SUCCESS = `${prefix}/SHOW_SUCCESS`
export const SHOW_FAILURE = `${prefix}/SHOW_FAILURE`

export const showUser = createAction((id: string) => ({
  type: [SHOW_REQUEST, SHOW_SUCCESS, SHOW_FAILURE],
  promise: (api: IApi) => api.user.show(id),
  id,
}))

export const CREATE_REQUEST = `${prefix}/CREATE_REQUEST`
export const CREATE_SUCCESS = `${prefix}/CREATE_SUCCESS`
export const CREATE_FAILURE = `${prefix}/CREATE_FAILURE`

export const createUser = createAction((data: Partial<IUser & { clientId?: string }>) => ({
  type: [CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE],
  promise: (api: IApi) => api.user.create(data),
}))

export const CHECK_EXISTING_CLIENT_LOGIN_REQUEST = `${prefix}/CHECK_EXISTING_CLIENT_LOGIN_REQUEST`
export const CHECK_EXISTING_CLIENT_LOGIN_SUCCESS = `${prefix}/CHECK_EXISTING_CLIENT_LOGIN_SUCCESS`
export const CHECK_EXISTING_CLIENT_LOGIN_FAILURE = `${prefix}/CHECK_EXISTING_CLIENT_LOGIN_FAILURE`

export const checkExistingClientLogin = createAction(
  (data: { email: string; clientId: string }) => ({
    type: [
      CHECK_EXISTING_CLIENT_LOGIN_REQUEST,
      CHECK_EXISTING_CLIENT_LOGIN_SUCCESS,
      CHECK_EXISTING_CLIENT_LOGIN_FAILURE,
    ],
    promise: (api: IApi) => api.user.checkExistingClientLogin(data),
  }),
)

export const UPDATE_REQUEST = `${prefix}/UPDATE_REQUEST`
export const UPDATE_SUCCESS = `${prefix}/UPDATE_SUCCESS`
export const UPDATE_FAILURE = `${prefix}/UPDATE_FAILURE`

export const updateUser = createAction(
  (id: string, data: Partial<IUser & { clientId?: string }>) => ({
    type: [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE],
    promise: (api: IApi) => api.user.update(id, data),
  }),
)

export const DELETE_REQUEST = `${prefix}/DELETE_REQUEST`
export const DELETE_SUCCESS = `${prefix}/DELETE_SUCCESS`
export const DELETE_FAILURE = `${prefix}/DELETE_FAILURE`

export const deleteUser = createAction((id: string, clientId?: string) => ({
  type: [DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE],
  promise: (api: IApi) => api.user.delete(id, clientId),
}))

export const INVITE_REQUEST = `${prefix}/INVITE_REQUEST`
export const INVITE_SUCCESS = `${prefix}/INVITE_SUCCESS`
export const INVITE_FAILURE = `${prefix}/INVITE_FAILURE`

export const inviteUser = createAction((id: string) => ({
  type: [INVITE_REQUEST, INVITE_SUCCESS, INVITE_FAILURE],
  promise: (api: IApi) => api.user.invite(id),
  id,
}))

const INVITE_LINK = createRequestTypes(prefix, 'INVITE_LINK')

export const [INVITE_LINK_REQUEST, INVITE_LINK_SUCCESS, INVITE_LINK_FAILURE] = INVITE_LINK

/**
 * Fetch a user's sign-in link without emailing it, for a BDO who sends the
 * invitation from their own thread. The link is a credential, so it is consumed
 * from the returned promise and never parked in the store.
 */
export const getUserInviteLink = createAction((id: string) => ({
  type: INVITE_LINK,
  promise: (api: IApi) => api.user.inviteLink(id),
  id,
}))

const TRACK_LINK_CLICK = createRequestTypes(prefix, 'TRACK_LINK_CLICK')

export const [TRACK_LINK_CLICK_REQUEST, TRACK_LINK_CLICK_SUCCESS, TRACK_LINK_CLICK_FAILURE] =
  TRACK_LINK_CLICK

export const trackLinkClick = createAction((params: object) => ({
  type: TRACK_LINK_CLICK,
  promise: (api: IApi) => api.user.track_link(params),
}))
